import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await register(form);
    setBusy(false);
    if (res.ok) {
      navigate("/", { replace: true });
    } else {
      setError(res.error);
    }
  };

  return (
    <div data-testid="register-page" className="mx-auto grid max-w-md px-4 py-16">
      <div className="rounded-3xl border border-line bg-white p-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.24em] text-muted-soft">Регистрация</div>
        <h1 className="mt-2 text-3xl font-extrabold tracking-tightest text-ink">Создайте аккаунт</h1>
        <p className="mt-2 text-sm text-muted">Быстрый доступ к заказам, избранному и сравнению.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-muted">ФИО</span>
            <input required data-testid="register-name" value={form.name} onChange={onChange("name")} className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink" />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-muted">Email</span>
            <input required type="email" data-testid="register-email" value={form.email} onChange={onChange("email")} className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink" />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-muted">Телефон</span>
            <input data-testid="register-phone" value={form.phone} onChange={onChange("phone")} className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink" />
          </label>
          <label className="block">
            <span className="mb-1 block text-xs font-semibold text-muted">Пароль (мин. 6 символов)</span>
            <input required type="password" data-testid="register-password" value={form.password} onChange={onChange("password")} className="w-full rounded-lg border border-line bg-white px-4 py-3 text-sm outline-none focus:border-ink" />
          </label>
          {error && (
            <div data-testid="register-error" className="rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger">{error}</div>
          )}
          <button
            data-testid="register-submit"
            disabled={busy}
            type="submit"
            className="w-full rounded-full bg-ink py-3 text-sm font-semibold text-white transition-colors hover:bg-ink-soft disabled:opacity-50"
          >
            {busy ? "Создаём…" : "Зарегистрироваться"}
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-muted">
          Уже есть аккаунт? <Link to="/login" className="font-semibold text-ink hover:underline">Войти</Link>
        </div>
      </div>
    </div>
  );
}
